import React, { Component } from 'react';
import { Wrapper } from 'components';
import styled from "react-emotion";
import userResearchIcon from '../shared/images/services/research.png';
import designThinkingIcon from '../shared/images/services/design_thinking.png';
import serviceDesignIcon from '../shared/images/services/service_design.png';
import prototypingIcon from '../shared/images/services/prototyping.png';
import userTestingIcon from '../shared/images/services/user_testing.png';
import architectureIcon from '../shared/images/services/architecture2.png';
import appDevIcon from '../shared/images/services/dev.png';
import managedServicesIcon from '../shared/images/services/managed_services.png';

const StyledServices = styled.div`
    max-width: 100%;
`;

const ServicesGrid = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.5rem 0 2rem 0rem;
    justify-content: space-evenly;
`;

const ServiceTile = styled.div`
    text-align: center;
    width: 20%;
    height: 10rem;
    background: #fff;
    border-radius: 2px;
    display: inline-block;
    margin: 1rem;
    margin-top: 3rem;
    border-bottom: 4px solid rgba(0, 0, 0, 0.06);
    border-bottom-color: ${props => props.theme.colors.lightBlue};
    border-radius: 8px;
    position: relative;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    @media (max-width:  ${props => '1079px'}) {
        height: 9rem;
        width: 27%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 25%;
        height: 11rem;
    }
    @media (max-width: ${props => '690px'}) {
        width: 40%;
        height: 11rem;
    }
    @media (max-width: ${props => '515px'}) {
        width: 40%;
        height: 9rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 40%;
        height: 8;
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}) {
        width: 39%;
        height: 10;
    }
`;

const ServiceTitle = styled.p`
    font-size: 1.1rem;
    opacity: 1;
    position: relative;
    top: -5%;
    line-height: 1;
    color: ${props => props.theme.colors.lightBlue};
    left: 0rem;
    width: 100%;
    margin-bottom: 0;
    padding-left: 5%;
    padding-right: 5%;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        top: -10%;
        font-size: 1.3rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        top: -10%;
        font-size: 1rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}) {
        top: -10%;
        font-size: 0.8rem;
    }
`;

const ServiceDescription = styled.p`
    position: absolute;
    font-size: .7rem;
    bottom: 0;
    margin-bottom: 1rem;
    text-align: center;
    color: #777;
    line-height: 130%;
    width: 100%;
    padding: 0rem 0.8rem 0rem 0.8rem;
    @media (max-width: ${props => '1110px'}) {
      font-size: 0.7rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
      font-size: 0.8rem;
      margin-bottom: 0.7rem;
    }
    @media (max-width: ${props => '690px'}) {
      font-size: 0.9rem;
      margin-bottom: 0.7rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
      font-size: 0.9rem;
      margin-bottom: 0.5rem;
    }
    @media (max-width: ${props => '515px'}) {
      font-size: 0.6rem;
      margin-bottom: 0.5rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}) {
      font-size: 0.6rem;
      margin-bottom: 0.5rem;
    }

`;

const ServiceIcon = styled.div`
    position: relative;
    right: 0;
    top: -12%;
    left: 32%;
    width: 35%;
    padding: 20px;
    background: White;
    border-radius: 50%;
    border: 2px solid ${props => props.theme.colors.lightBlue};
    opacity: 1;
    font-size: 0.8rem;
    @media (max-width:  ${props => '1079px'}) {
      width: 32%;
      top: -17%;
      left: 34%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
      width: 34%;
      top: -15%;
      left: 34%;
    }
    @media (max-width: ${props => '770px'}) {
      width: 40%;
      top: -20%;
      left: 30%;
    }
    @media (max-width: ${props => '690px'}) {
      width: 40%;
      top: -25%;
      left: 30%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
      width: 37%;
      top: -16%;
      left: 31%;
    }
    @media (max-width:  ${props => '470px'}) {
      width: 60%;
      top: -32%;
      left: 20%;
    }
    @media (max-width:  ${props => '423px'}) {
      width: 60%;
      top: -30%;
      left: 20%;
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}) {
      width: 60%;
      top: -25%;
      left: 20%;
    }

`;

class Services extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const servicesList = [
            {
                "Title": "User Research",
                "Description": "We offer qualitative and quantitative research services.",
                "Icon": userResearchIcon
            },
            {
                "Title": "Design Thinking",
                "Description": "Visit our purpose-built design centre for DT workshops.",
                "Icon": designThinkingIcon
            },
            {
                "Title": "Service Design",
                "Description": "Service blueprints visualise opportunities for business optimisation.",
                "Icon": serviceDesignIcon
            },
            {
                "Title": "Prototyping",
                "Description": "Our interactive prototypes collect valuable feedback from users.",
                "Icon": prototypingIcon
            },
            {
                "Title": "User Testing and Validation",
                "Description": "We conduct testing to ensure user needs are met.",
                "Icon": userTestingIcon
            },
            {
                "Title": "Architecture",
                "Description": "We’re experts in enterprise architecture, we offer secure integration.",
                "Icon": architectureIcon
            },
            {
                "Title": "Application Development",
                "Description": "We offer agile development for digital solutions.",
                "Icon": appDevIcon
            },
            {
                "Title": "Managed Services",
                "Description": "Management of digital solutions for managed cloud solutions.",
                "Icon": managedServicesIcon
            }
        ];
        const tiles = servicesList.map((service, i) =>
            <ServiceTile key={i}>
                <ServiceIcon className='service-icon'>
                        <img src={service.Icon} alt="null"/>
                    </ServiceIcon>
                <ServiceTitle className='service-title'>{service.Title}</ServiceTitle>
                <ServiceDescription className='service-description'>{service.Description}</ServiceDescription>
            </ServiceTile>
        );
        return (
            <StyledServices>
                <Wrapper>
                    <div className='services-title'>
                        <h3 style={{ margin: 0 }}>Services</h3>
                    </div>
                    <ServicesGrid>
                        {tiles}
                    </ServicesGrid>
                </Wrapper>
            </StyledServices>
        );
    }
}

export default Services;
